import React, {useState} from "react";
import HeroSection from "assets/images/lendersHero.png";
import HeroSectionMobile from "assets/images/lendersHeroMobile.png";
import Button from "components/shared/Button";
import { ContactModal } from "pages/enterprises/components/HeroSection";

const Hero = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };

  return (
    <>
    <div className="bg-ashShade-17 px-4 md:px-12 w-full py-16 flex items-center justify-center flex-col gap-20 mb-10">
      <div className="flex flex-col items-center justify-center gap-10">
        <div className="flex items-center justify-center flex-col gap-6">
          <h1 className="font-bold text-5xl text-bblack-5 lg:w-[15ch] text-center">
            Finance projects with clarity and confidence.
          </h1>
          <p className="sm:w-[56ch] w-full text-center text-bblack-6">
            Gain real-time visibility of your entire portfolio, de-risk every
            disbursement, ensure stakeholder accountability, and enhance project
            lending with data-driven insights.
          </p>
          <Button
            label="Book a Demo"
            className=" !bg-blueShades-4 !py-[10px] !px-[18px]"
            onClick={toggleModal}
          />
        </div>

        <img
          src={HeroSection}
          alt="Hero Section"
          className="w-full object-contain sm:block hidden"
        />
        <img
          src={HeroSectionMobile}
          alt="Hero Section"
          className="w-full object-contain block sm:hidden"
        />
      </div>
    </div>
    {modal && <ContactModal closer={toggleModal} />}
    
    
    </>
  );
};

export default Hero;
